import { AnnotationVariant } from 'components/parts/common/annotation';

// localhost
export const LOCALHOST = 'http://localhost:3000';

// ルートURL
export const ROOT_URL =
  process.env.REACT_APP_ROOT_URL !== undefined
    ? process.env.REACT_APP_ROOT_URL
    : '';

// RSI ログアウトエンドポイント
export const ENDPOINT_RSI_LOGOUT =
  'https://devu.accounts.ricoh.com/portal/logout.html';

// 自動認証エンドポイント
export const ENDPOINT_LOGIN = process.env.REACT_APP_ENDPOINT + '/login';

// CaaS ログアウトエンドポイント
export const ENDPOINT_LOGOUT = process.env.REACT_APP_ENDPOINT + '/logout';

// トークン取得エンドポイント
export const ENDPOINT_USER_TOKEN =
  process.env.REACT_APP_ENDPOINT + '/user/token';

// 本人情報を取得する
export const ENDPOINT_RSI_GET_ME =
  process.env.REACT_APP_RSI_ENDPOINT_API + '/v1/aut/me';

// 共通設定サイト URL
export const RSI_PORTAL_URL = `https://${process.env.REACT_APP_RSI_ENV}.accounts.ricoh.com/portal/top.html`;

// アプリ一覧取得エンドポイント
export const ENDPOINT_WORKFLOW_APPS =
  process.env.REACT_APP_ENDPOINT + '/workflowApps';

// 設定エンドポイント
export const ENDPOINT_SETTINGS = process.env.REACT_APP_ENDPOINT + '/settings';

// execute-Key 再発行エンドポイント
export const ENDPOINT_UPDATE_EXECUTE_KEY =
  process.env.REACT_APP_ENDPOINT + '/settings/execute-key';

// ログ取得エンドポイント
export const ENDPOINT_LOGS = process.env.REACT_APP_ENDPOINT + '/logs';

// 実行ログパラメータ取得エンドポイント
export const ENDPOINT_LOGPARAMETER =
  process.env.REACT_APP_ENDPOINT + '/logParameter';

// リソースオーナーの認可要求コード取得エンドポイント
export const ENDPOINT_CODE = process.env.REACT_APP_ENDPOINT + '/code';

// リフレッシュトークンエンドポイント
export const ENDPOINT_TOKEN = process.env.REACT_APP_ENDPOINT + '/token';

// 認可要求
export const RSI_AUTHORIZATION = `https://${process.env.REACT_APP_RSI_ENV}.accounts.ricoh.com/v1/aut/oauth/provider/authorize`;

// トークン取得
export const RSI_AUTHORIZATION_TOKEN = `https://${process.env.REACT_APP_RSI_ENV}.accounts.ricoh.com/v1/aut/oauth/provider/token`;

export const FORMAT_DATE_SLASH = 'YYYY/MM/DD HH:mm:ss';
export const FORMAT_DATE_ISO = 'YYYY-MM-DD HH:mm:ss';

// アノテーション
export type Annotation = {
  VARIANT: AnnotationVariant;
  MESSAGE: string;
};
export const SETTINGS_ANNOTATION = {
  GET_FAILED: {
    VARIANT: 'negative',
    MESSAGE: '設定情報の取得に失敗しました',
  } as Annotation,
  UPDATE_SUCCESS: {
    VARIANT: 'positive',
    MESSAGE: 'execute-Key を再発行しました',
  } as Annotation,
  UPDATE_FAILED: {
    VARIANT: 'negative',
    MESSAGE: 'execute-Key の再発行に失敗しました',
  } as Annotation,
  WF_APP_NOT_FOUND: {
    VARIANT: 'negative',
    MESSAGE: 'WF アプリがありません',
  } as Annotation,
};

export const WORKFLOW_ANNOTATION = {
  LICENSE_BEFORE_EXPIRATION: {
    VARIANT: 'yellow',
    MESSAGE: `翌月にライセンス契約が終了する契約が存在します。
      アプリの使用量を確認し、共通設定サイトで不要なアプリを削除してください。
      登録日時が新しいものから使用できなくなります。`,
  } as Annotation,
};
